import { Icon } from '@iconify/react';
import logInFill from '@iconify/icons-eva/log-in-fill';
// routes
import { PATH_AUTH, PATH_PAGE } from '../../routes/paths';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22
};

const menuConfig = [
  {
    title: 'Home',
    path: PATH_PAGE.root
  },
  {
    title: 'Pricing',
    path: PATH_PAGE.pricing
  },
  {
    title: 'Terms of Service',
    path: PATH_PAGE.TermsOfService
  },
  {
    title: 'Privacy Policy',
    path: PATH_PAGE.PrivacyPolicy
  },
  {
    title: 'Login',
    icon: <Icon icon={logInFill} {...ICON_SIZE} />,
    path: PATH_AUTH.login
  }
];

export default menuConfig;
